// Core compound table + hook
export { DataTable } from './DataTable';
export type { DataTableProps } from './DataTable';
export { useDataTable } from './context';
